module.exports = __webpack_public_path__ + "static/media/400.bd06f61e.png";